// extracted by mini-css-extract-plugin
module.exports = {"defaultTablist":"TabBar_defaultTablist__WB4oJ","defaultTab":"TabBar_defaultTab__eo6Ar","neoTablist":"TabBar_neoTablist__raOs3"};